import React from 'react';
import { render } from 'react-dom';
import ReturnsSidebar from '../../react-components/ReturnsSidebar/ReturnsSidebar';
import Spinner from '@narvar/nth-spinner';
import List from '@narvar/nth-list';
import TextArea from '@narvar/nth-text-area';
import Alert from '@narvar/nth-alert';
import Button, { outline } from '@narvar/nth-button';
import { store } from '../../store';
import s from './blindRepairSidebar.module.css';
import SidebarSectionTitle from '../../react-components/SidebarSectionTitle/SidebarSectionTitle';
import ButtonMenu from '../../react-components/ButtonMenu';
import SidebarHTMLContent from '../../react-components/SidebarHTMLContent/SidebarHTMLContent';
import DeleteIcon from '../ImageUploader/components/DeleteIcon';
import EditIcon from '../ImageUploader/components/EditIcon';

const buttonMenuItems = (inputKey, multipleSelect, sidebarState) => {
  const { currentItem } = sidebarState;
  const { repairReasons } = currentItem;
  const selectedItem = currentItem[inputKey] && [currentItem[inputKey]];
  return multipleSelect || !selectedItem ? repairReasons : selectedItem;
};

const SidebarSection = ({
  title,
  index,
  components,
  disabled,
  buildFormState,
  handleDismissOnClick,
  checkDisabledSection,
}) => {
  const currentItem = sidebarState.currentItem || {};
  const repairReasons = currentItem && currentItem.repairReasons;

  const componentsMarkup = components.map((component) => {
    const componentKey = btoa(Math.random());
    const { name, inputKey, required, panel: panelLink, content, center, text } = component;
    buildFormState(component);

    if (required) {
      checkDisabledSection(inputKey, index);
    }

    if (name === 'SidebarPanelLink') {
      return (
        <div
          key={componentKey}
          onClick={() => actions.switchPanel(panelLink)}
          className={s.panel_link}
        >
          {text}
        </div>
      );
    } else if (name === 'ButtonMenu') {
      return (
        <ButtonMenu
          key={inputKey}
          menuItems={buttonMenuItems(inputKey, component.multipleSelect, sidebarState)}
          itemKey="reason_code_id"
          propName="display_name"
          formKey={inputKey}
          itemClick={(reasonIndex) => {
            if (reasonSelected(repairReasons[reasonIndex], 'display_name', inputKey)) {
              actions.resetReason(reasonIndex, inputKey);
            } else {
              actions.selectReason(reasonIndex, inputKey, component.multipleSelect);
            }
          }}
          checkSelected={reasonSelected}
          multipleSelect={component.multipleSelect}
        />
      );
    } else if (name === 'SidebarHtmlContent') {
      return <SidebarHTMLContent key={componentKey} html={content} centerContent={center} />;
    } else if (name === 'TextInput') {
      return (
        <TextInput
          key={inputKey}
          id={inputKey}
          className={`sidebar-input ${currentItem[inputKey] ? 'filled-input' : ''}`}
          name={inputKey}
          label={component.label}
          onChange={(data) => actions.formChange(data, index)}
          type={component.type || text}
          defaultValue={currentItem[inputKey]}
          maxLength={100}
        />
      );
    } else if (name === 'TextArea') {
      return (
        <TextArea
          key={inputKey}
          id={inputKey}
          className={`sidebar-comments ${currentItem[inputKey] ? 'filled-input' : ''}`}
          style={{ width: '100%' }}
          name={inputKey}
          label={component.placeholder}
          onChange={(data) => actions.formChange(data)}
          value={currentItem[inputKey]}
        />
      );
    } else if (name === 'ImageUploader') {
      return (
        <div>
          <Alert
            show={currentItem.fileSizeExceeded}
            dismissible
            dismissOnClick={handleDismissOnClick}
            s={{
              padding: '15px',
              borderStyle: 'none',
              backgroundColor: '#e53e3a',
              color: '#f3f3f3',
            }}
          >
            {language['returns.step_1.sidepanel_file_size_error_tooltip']}
          </Alert>

          <input
            id="fileInput"
            type="file"
            accept=".png, .jpg, .jpeg"
            onChange={actions.uploadFile}
            ref={(node) => (customerFileUpload = node)}
            style={{ display: 'none' }}
          />
          <label
            id="fileInputUploadLabel"
            htmlFor="fileInput"
            style={{
              marginTop: '1rem',
              padding: '15px',
              border: '1px solid black',
              width: '100%',
              cursor: 'pointer',
              display:
                !currentItem.repairImageUrl && !currentItem.repairPhotoData ? 'block' : 'none',
            }}
          >
            Choose Files
          </label>

          <div
            id="imageThumbnailContainer"
            className="imagePreview"
            style={{
              display: currentItem.repairImageUrl || currentItem.repairPhotoData ? 'block' : 'none',
              padding: '15px',
              border: '1px solid black',
              height: '100px',
            }}
          >
            <img
              id="imageThumbnail"
              src={currentItem.repairImageUrl}
              style={{ width: '70px', height: '70px', float: 'left' }}
            />
            <span style={{ float: 'right', padding: '25px 0 0 0' }}>
              <span style={{ padding: '10px', cursor: 'pointer' }} onClick={retakePhoto}>
                <EditIcon />
              </span>
              <span style={{ padding: '10px', cursor: 'pointer' }} onClick={actions.deletePhoto}>
                <DeleteIcon />
              </span>
            </span>
          </div>
        </div>
      );
    }

    return null;
  });

  return (
    <div>
      {title ? (
        <SidebarSectionTitle index={index} title={`${index + 1}. ${title}`} disabled={disabled} />
      ) : null}
      {disabled ? null : componentsMarkup}
    </div>
  );
};
export const renderBlindRepairSidebar = ({
  sidebarState,
  checkCommentField,
  node,
  checkRequiredFields,
  buildFormState,
  checkDisabledSection,
}) => {
  const { language } = store.getState();
  const { config, open, loading, panel, currentItem, savedItems } = sidebarState;
  const itemCategory = currentItem && currentItem.itemCategory;
  const itemName = currentItem && currentItem.itemDescription;
  const savedItem = savedItems[itemName];
  const lastEnabledSection = currentItem ? currentItem.lastEnabledSection : null;
  const disableSections = lastEnabledSection !== null;
  const currentPanel = config.panels[panel];
  const commentEmpty = checkCommentField();
  let unrenderedSectionCount = 0;

  render(
    <div>
      <ReturnsSidebar
        title={currentPanel.title}
        toggleSide="right"
        sidebarOpen={open}
        backIconOnClick={panel ? () => actions.switchPanel(0) : null}
        closeIconOnClick={() => actions.toggle()}
        overlayOnClick={() => actions.toggle()}
      >
        {loading ? (
          <Spinner style={{ width: '4rem' }} />
        ) : (
          <List className={s.content_list} slideDirection="right">
            <div key={currentPanel.title}>
              {currentPanel.sections.map((section, index) => {
                const { title, components, condition } = section;
                const renderedSectionIndex = index - unrenderedSectionCount;

                if (condition && condition !== itemCategory) {
                  unrenderedSectionCount += 1;
                  return null;
                }

                return (
                  <SidebarSection
                    {...{
                      key: title,
                      title,
                      index: renderedSectionIndex,
                      components,
                      disabled: disableSections && index > lastEnabledSection,
                      buildFormState,
                      checkDisabledSection,
                    }}
                  />
                );
              })}

              {panel === 0 ? (
                <div>
                  <hr />
                  <Button
                    className="narvar-btn-primary sidebar-done-button sidebar-action-btn"
                    big
                    disabled={checkRequiredFields() || commentEmpty}
                    onClick={() => actions.finalizeItem()}
                  >
                    {language['returns.step_1.sidepanel_next']}
                  </Button>

                  {!checkRequiredFields() && !commentEmpty ? (
                    <Button
                      className="narvar-btn-secondary sidebar-additional-items-button sidebar-action-btn"
                      s={{ marginTop: '1rem', ...outline() }}
                      big
                      onClick={() => actions.finalizeItem(true)}
                    >
                      {language['returns.step_1.sidepanel_additional_items']}
                    </Button>
                  ) : null}

                  {savedItem && savedItem.selected ? (
                    <Button
                      className="narvar-btn-secondary sidebar-cancel-item-button sidebar-action-btn"
                      onClick={() => actions.deleteItem()}
                      s={{ marginTop: '1rem' }}
                      big
                    >
                      {language['returns.step_1.sidepanel_dont_return']}
                    </Button>
                  ) : null}
                </div>
              ) : null}
            </div>
          </List>
        )}
      </ReturnsSidebar>
    </div>,
    node,
  );
};
